import {
  FoodBottomInfo,
  FoodBrand,
  FoodImageBox,
  FoodInfoBox,
  FoodLeft,
  FoodName,
  FoodNameBox,
  FoodNutrient,
  MealCalorie,
  StyledFoodListItem,
} from "./styled"
import { getDisplayCalories, getDisplayPortion } from "utils"
import SmallFoodImage from "components/foodDetails/share/SmallFoodImage"
import { useFoodBrandMaxWidth } from "utils/hooks"
import { formatEdamaUnit } from "utils/formater"
import { IngredientType } from "model/food/types"

interface IProps {
  ingredient: IngredientType
  onSelect?: (food: IngredientType) => void
  isManualNutrition?: boolean
}

const ViewOnlyIngredient = (props: IProps) => {
  const { ingredient, isManualNutrition, onSelect } = props
  const { name, calorie, unit, portion } = ingredient

  const brand = "brand" in ingredient ? ingredient.brand : ""
  const imageSrc = "imageUrl" in ingredient ? ingredient.imageUrl : undefined

  const { foodNutritionRef, brandMaxWidth } = useFoodBrandMaxWidth({
    brand,
  })

  return (
    <StyledFoodListItem>
      <FoodLeft onClick={() => onSelect?.(ingredient)}>
        <FoodImageBox>
          <SmallFoodImage src={imageSrc} />
        </FoodImageBox>

        <FoodInfoBox>
          <FoodNameBox>
            <FoodName>{name}</FoodName>
          </FoodNameBox>

          {!isManualNutrition && (
            <FoodBottomInfo>
              <FoodNutrient ref={foodNutritionRef}>
                {getDisplayPortion(portion)} {formatEdamaUnit(unit)}
              </FoodNutrient>

              {brand && (
                <FoodBrand style={{ maxWidth: brandMaxWidth }}>
                  <p>{brand}</p>
                </FoodBrand>
              )}
            </FoodBottomInfo>
          )}
        </FoodInfoBox>
      </FoodLeft>
      {!isManualNutrition ? (
        <MealCalorie>{getDisplayCalories(calorie)} cal</MealCalorie>
      ) : (
        ""
      )}
    </StyledFoodListItem>
  )
}

export default ViewOnlyIngredient
